import { apiClient } from '@/api/client'
import {
  SUPPORT_TICKETS,
  supportTicketByIdPath,
  supportTicketMessagesPath,
  supportTicketResolvePath,
} from '@/api/endpoints'
import type { ApiResponseWrapper } from '@/types/api.types'
import type {
  CreateTicketPayload,
  TicketDetail,
  TicketListResponse,
} from '@/types/support-ticket.types'

function unwrap<T>(value: ApiResponseWrapper<T> | T): T {
  const wrapped = value as ApiResponseWrapper<T>
  return wrapped?.data !== undefined ? wrapped.data : (value as T)
}

export async function listSupportTickets(): Promise<TicketListResponse> {
  const { data } = await apiClient.get<ApiResponseWrapper<TicketListResponse>>(SUPPORT_TICKETS)
  const payload = unwrap(data)
  return {
    items: Array.isArray(payload?.items) ? payload.items : [],
    seesWholeOrganization: payload?.seesWholeOrganization === true,
  }
}

export async function getSupportTicket(id: string): Promise<TicketDetail> {
  const { data } = await apiClient.get<ApiResponseWrapper<TicketDetail>>(
    supportTicketByIdPath(id)
  )
  return unwrap(data)
}

export async function createSupportTicket(payload: CreateTicketPayload): Promise<TicketDetail> {
  const { data } = await apiClient.post<ApiResponseWrapper<TicketDetail>>(
    SUPPORT_TICKETS,
    payload
  )
  return unwrap(data)
}

export async function replyToSupportTicket(id: string, body: string): Promise<TicketDetail> {
  const { data } = await apiClient.post<ApiResponseWrapper<TicketDetail>>(
    supportTicketMessagesPath(id),
    { body }
  )
  return unwrap(data)
}

export async function resolveSupportTicket(id: string): Promise<TicketDetail> {
  const { data } = await apiClient.post<ApiResponseWrapper<TicketDetail>>(
    supportTicketResolvePath(id)
  )
  return unwrap(data)
}
